module.exports = "<div class=\"welcome\" fxLayout=\"column\" fxLayout.gt-md=\"row\" fxLayoutGap.gt-md=\"20px\" fxLayoutAlign=\"center\">\n<section>\n  <h1>ACTIVITY</h1>\n  <p>Stay active and enjoy better health and more fun!</p>\n</section>\n<section>\n  <h1>COMMUNITY</h1>\n  <p>Get to know other people who share your passion!</p>\n</section>\n<section>\n  <h1>CHALLANGES</h1>\n  <p>Never stop! Dive into new challenges every day.</p>\n</section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome/welcome.component.html
// module id = ./src/app/welcome/welcome.component.html
// module chunks = main